module.exports = __webpack_public_path__ + "static/img/特大暴雨.5bf798d8.svg";